<template>
    <div>
        <div class="row mb-3">
            <search-bar v-model="searchString"
                        class="col-md-8"
                        placeholder="Nach Namen suchen ..."></search-bar>

            <div class="col-12 col-md-4 d-md-flex justify-content-end mb-3">
                <button v-if="!isNew"
                        class="btn btn-success w-100"
                        type="button" @click="isNew = true">Neu <i class="fas fa-plus"></i></button>
                <button v-if="isNew"
                        class="btn btn-danger w-100"
                        type="button" @click="isNew = false">Abbrechen <i class="fas fa-times"></i>
                </button>
            </div>
        </div>

        <transition mode="out-in" name="slide">
            <buero-form v-if="isNew"
                        :schema="schema"
                        class="mb-5"
                        method="post"
                        url="/api/merchant/vouchers"
                        @addItem="addItem"
                        @cancel="cancel"></buero-form>
        </transition>

        <no-data v-if="hasNoData"></no-data>

        <loader v-if="!hasNoData && isLoading"></loader>

        <voucher v-for="(item, index) in filteredList"
                 v-if="!isLoading"
                 :key="item.id"
                 :data-index="index"
                 :item="item"
                 @deleteItem="deleteItem"></voucher>

    </div>
</template>

<script>
import {Form} from './Form';
import Voucher from './Voucher';

export default {
    name: 'Vouchers',
    components: {Voucher},
    data() {
        return {
            items: [],
            searchString: null,
            schema: (new Form('Gutschein hinzufügen')).schema(),
            fetchingData: true,
            isLoading: true,
            hasNoData: false,
            isNew: false,
        };
    },
    created() {

        axios.get('/api/merchant/vouchers').then((response) => {
            this.items = response.data.data;
            if (response.data.data.length === 0) {
                this.hasNoData = true;
            }

            if (response.data.data.length > 0) {
                this.isLoading = false;
            }
        }).catch((errors) => {
            this.$swal({
                icon: 'error',
                title: 'Die Daten konnten nicht geladen werden',
            });
            this.isLoading = false;
            this.hasNoData = true;
        });
    },
    methods: {
        cancelNew() {
            this.isNew = false;
        },
        addItem(payload) {
            this.items.unshift(payload);
            this.$emit('cancel');
            this.cancelNew();
        },
        cancel(value) {
            this.$emit('cancel', value);
            this.cancelNew();
        },
        deleteItem(payload) {
            this.items.forEach((element, index) => {
                if (element.id === payload) {
                    this.items.splice(index, 1);
                }
            });
        },
    },
    watch: {
        searchString(newValue) {
            this.searchString = newValue;
        },
    },
    computed: {
        filteredList() {
            if (!this.searchString) {
                return this.items;
            }
            return this.items.filter(element => {
                return element.offer.toLowerCase().includes(this.searchString.toLowerCase());
            });
        },
    },

};
</script>
